var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDart(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 94,
    viewBox: "0 0 94 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 94,
    rx: 10,
    fill: "#5FC9E1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9467 25.9502C25.9467 25.9502 39.4213 19.2169 46.1573 15.8462C47.3833 15.2418 48.7408 14.9531 50.1067 15.0062C52.1493 15.1315 54.5787 17.1075 54.5787 17.1075L79 41.5315V67.6355H67.632V79.0035H41.104L17.104 55.0035C15.808 53.6702 15 51.7902 15 49.9502C15 49.0995 15.48 47.7689 15.8427 47.0035L25.9467 25.9502ZM27.7573 27.7609V59.1929C27.7627 60.6409 27.8133 61.9235 29.0853 63.2142L42.2107 76.3369H64.9653V64.9689L27.7573 27.7609ZM59.904 25.9529C57.5067 23.5635 55.08 21.2062 52.5973 18.9049C51.792 18.1929 51.0853 17.6569 49.744 17.6729C48.7573 17.7102 47.424 18.1929 47.424 18.1929L31.9093 25.9502L59.904 25.9529Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDart);
export default __webpack_public_path__ + "static/media/dart.70c34cf538e7aca3bc93459b5c412601.svg";
export { ForwardRef as ReactComponent };